/**
 * Opens a payment link in a new tab.
 *
 * Must be called synchronously from a user-gesture handler (onClick) — wrapping
 * this in setTimeout/await breaks the gesture chain and Safari (especially iOS)
 * will silently block the popup with no visible indicator to the user.
 *
 * Returns false when the browser blocked the popup, so callers can show a
 * fallback UI instead of leaving the user stuck with no feedback.
 */
export function openPaymentWindow(url: string): boolean {
  if (!url) return false;

  const newTab = window.open(url, '_blank');
  if (!newTab) return false;

  // Manual reverse-tabnabbing protection instead of the 'noopener' window
  // feature, which makes some browsers return null even on success and
  // breaks the blocked/opened detection above.
  try {
    newTab.opener = null;
  } catch {
    // ignore - cross-origin access after navigation may throw
  }

  return !newTab.closed;
}
